export default __webpack_public_path__ + "static/img-finish-products-4109cd68b6a6f72d760db8e104da45c7.webp";